<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="phone" />
          {{ $t('callHistory') }}
        </h1>
      </div>
    </div>
    <call-list></call-list>
  </main>
</template>

<script>
import CallList from "@/views/client/CallList.vue";

export default {
  components: { CallList },
  data() {
    return {
    }
  },
  i18n: {
    messages: {
      en: {
        older: "Older",
        callHistory: "Call history"
      },
      vi: {
        older: "Cũ hơn",
        callHistory: "Lịch sử gọi"
      }
    }
  }
}
</script>